"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgAppsDashboard(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M8 12H4v4h4zM8 0H4v4h4zm0 6H4v4h4zm6 6h-4v4h4zm0-12h-4v4h4zm0 6h-4v4h4zm6-6h-4v4h4zm0 6h-4v4h4zm0 6h-4v4h4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('AppsDashboard')(SvgAppsDashboard);
//# sourceMappingURL=AppsDashboard.js.map